/**
 * Listings in these categories are purchased via in-platform cart/checkout.
 * All other categories (cars, real estate, heavy materials, …) are
 * contact-only ads and never enter the cart.
 *
 * The list lives in /shared so both the server policy guard and the
 * client UI read the same source of truth.
 */
export const BUYABLE_LISTING_CATEGORIES = [
  "alisveris",
  "riyada",
  "atfal",
  "tibbi",
  "yedek-parca",
] as const;

export type BuyableListingCategory = (typeof BUYABLE_LISTING_CATEGORIES)[number];

export function isBuyableListingCategory(category: string | null | undefined): boolean {
  if (!category || typeof category !== "string") return false;
  return (BUYABLE_LISTING_CATEGORIES as readonly string[]).includes(category);
}
